module.exports = __webpack_public_path__ + "assets/img/9a6576ae04427f5cca29cedabc451992.svg";